<section>
  <div class="mb-2">
    <form novalidate [formGroup]="formAccountingModelDetail">
      <div class="row py-1">
        <div class="col field-concept-invoicing">
          <app-custom-autocomplete formControlName="conceptInvoicingId" [labelText]="'Concepto Fra.'"
            [list]="listConceptInvoicing" [required]="true" (onChangeSelect)="getConceptInvoicing($event, true)">
          </app-custom-autocomplete>
        </div>
        <div class="col field-family">
          <app-custom-autocomplete formControlName="familyId" [labelText]="'Familia'" [list]="listFamily"
            (onChangeSelect)="getFamily($event, true)"></app-custom-autocomplete>
        </div>
        <div class="col field-article">
          <app-custom-autocomplete formControlName="articleId" [labelText]="'Artículo'"
            [list]="listArticle"></app-custom-autocomplete>
        </div>
        <div class="col field-sales-account">
          <app-custom-input-text formControlName="salesAccount" [labelText]="'Cta.Venta'"></app-custom-input-text>
        </div>
        <div class="col field-sales-return-account">
          <app-custom-input-text formControlName="salesReturnAccount"
            [labelText]="'Cta.Dev.Vta'"></app-custom-input-text>
        </div>
        <div class="col field-cost-center">
          <app-custom-input-text formControlName="accountingCostCenter"
            [labelText]="'CCo.Contab.'"></app-custom-input-text>
        </div>
        <div class="field-buttons d-flex align-items-end justify-content-end mt-2 gap-2">
          <app-custom-button [title]="'Guardar'" [label]="'Guardar'" [severity]="'success'"
            (onClick)="send()"></app-custom-button>
          <app-custom-button [title]="'Cancelar'" [label]="'Cancelar'" [severity]="'danger'"
            (onClick)="clearForm()"></app-custom-button>
        </div>
      </div>
    </form>
  </div>
</section>